const merchantIdColumn = () => ({
	name: "merchantId",
	type: "input" as const,
	placeholder: "Merchant ID",
});

export default merchantIdColumn;
